import type { IInstallationPoint } from '@model/installationPoint';

export const getActionsItemAddButtonConfig = (
  point?: IInstallationPoint,
): { canCreateNewAI: boolean; aiType?: 'regular' | 'waitesWireless' } => {
  const hasRegular = point?.activeRegularAi;
  const hasWireless = point?.activeWwAi;

  if (hasRegular && hasWireless) {
    return { canCreateNewAI: false };
  }

  if (hasRegular) {
    return { canCreateNewAI: true, aiType: 'waitesWireless' };
  }

  if (hasWireless) {
    return { canCreateNewAI: true, aiType: 'regular' };
  }

  return { canCreateNewAI: true };
};
